import { connect } from 'react-redux';

const mapStateToProps = ({ drawDown }) => ({
    ...drawDown
});

const mapDispatchToProps = () => ({});

const ViewGuarantorAgreementModal = () => {
    return <div>View guarantor agreement modal</div>;
};

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewGuarantorAgreementModal);
